import { render, staticRenderFns } from "./mobilePay.vue?vue&type=template&id=5d0da34e&scoped=true"
import script from "./mobilePay.vue?vue&type=script&lang=js"
export * from "./mobilePay.vue?vue&type=script&lang=js"
import style0 from "./mobilePay.vue?vue&type=style&index=0&id=5d0da34e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0da34e",
  null
  
)

export default component.exports